import { ButtonConfig } from '../../../types/andTypes'
import Button from '../../atoms/Button/button'
import { PopupCard, Header, ButtonFlexBox, RedHeader } from './popup-styles'
import { CrossIcon } from '../../../svg/cross-icon'
import IconButton from '../../atoms/IconButton/icon-button'

export type PopupCardProps = {
  header: string
  children: JSX.Element | JSX.Element[]
  buttonConfig?: ButtonConfig[]
  hasRedHeader?: boolean
  onPopupClose?: () => void
}

const Popup = ({ header, children, buttonConfig, hasRedHeader, onPopupClose }: PopupCardProps) => {
  return (
    <PopupCard>
      {!!onPopupClose && (
        <IconButton labelText="Close Button" onClick={onPopupClose} icon={CrossIcon} />
      )}
      {hasRedHeader ? <RedHeader>{header}</RedHeader> : <Header>{header}</Header>}
      {children}
      <ButtonFlexBox>
        {buttonConfig &&
          buttonConfig.map((button, index) => (
            <Button
              key={index}
              altText={button.altText}
              isRightArrow={false}
              buttonText={button.text}
              onClick={button.onClick}
              isPrimary={button.isPrimary}
              isCircle={button.isCircle}
              maxContent={button.maxContent}
              disable={button.disabled}
            />
          ))}
      </ButtonFlexBox>
    </PopupCard>
  )
}

export default Popup
